import {isEqual} from 'lodash'
// import {validations} from '../../../../../mocks/laiaAccounts/factory.js'
import template from './calltrackingProviders.pug'
import integrationsUtils from '../../../services/integrations-utils'

export default Vue.extend({
  template: template(),
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    errors: {
      type: Array,
      default: () => ([])
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ready: false,
      dataAux: [],
      calltrackingProviders: []
    }
  },
  watch: {
    // cada vez que se cambia el calltrackingProviders
    // emitimos el valor para mantener el v-model actualizado
    calltrackingProviders: {
      deep: true,
      handler(_newVal, oldVal) {
        // con el if evitamos que se emita la primera vez cuando se inicializa
        if (oldVal) this.$emit('input', JSON.parse(JSON.stringify(this.calltrackingProviders)))
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        // Solo se debe de ejecutar cuando se produce un cambio
        if (isEqual(newValue, this.calltrackingProviders)) return

        this.initializeData()
      }
    }
  },
  created() {
    this.initializeData()
    this.loadCallTrackingProviders()
  },
  methods: {
    loadCallTrackingProviders() {
      const persistent = JSON.parse(JSON.stringify(this.value))
      this.calltrackingProviders = []
      API.callTrackingProviders.index({page: {number: 1, size: 1000}}).then(({data}) => {
        this.calltrackingProviders = data.map(item => {
          const existProvider = persistent.find(({id}) => id === item.id)
          if (existProvider) {
            return {...existProvider, active: true}
          }
          return {...item, active: false, providerAccountId: '', authToken: ''}
        })
      })
    },
    getSrc(name) {
      return integrationsUtils.getSrc(name)
    },
    initializeData() {
      this.dataAux = JSON.parse(JSON.stringify(this.value))
      this.ready = true
    },

    t(key, options = {}) {
      return this.$t(`laiaAccounts.form.${key}`, options)
    }
  }
})
